import { Box } from '@mantine/core';
import Drawer from '../drawer/Drawer';
import SearchableProposalList from './SearchableProposalList';
import { TCommercialProposal } from '@/models/commercial-proposal';

interface ProposalSelectorProps {
  opened: boolean;
  onClose: () => void;
  onSelect: (proposal: TCommercialProposal) => void;
}

export default function ProposalSelector({
  opened,
  onClose,
  onSelect,
}: ProposalSelectorProps) {
  return (
    <Drawer
      opened={opened}
      onClose={onClose}
      title="Select Commercial Proposal"
      padding="md"
      className="no-block-deselect"
    >
      <Box p="xs">
        <SearchableProposalList onSelect={onSelect} />
      </Box>
    </Drawer>
  );
}
